var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    clipPath: "url(#clip0_2618_104832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9998 11.4465C7.56177 11.4473 7.12787 11.3617 6.72293 11.1947C6.31798 11.0277 5.94992 10.7825 5.6398 10.4732L0.193131 5.02652C0.0675956 4.90098 -0.00292969 4.73072 -0.00292969 4.55318C-0.00292969 4.37565 0.0675956 4.20539 0.193131 4.07985C0.318667 3.95431 0.48893 3.88379 0.666465 3.88379C0.843999 3.88379 1.01426 3.95431 1.1398 4.07985L6.58646 9.52652C6.96147 9.90105 7.4698 10.1114 7.9998 10.1114C8.5298 10.1114 9.03813 9.90105 9.41313 9.52652L14.8598 4.07985C14.9853 3.95431 15.1556 3.88379 15.3331 3.88379C15.5107 3.88379 15.6809 3.95431 15.8065 4.07985C15.932 4.20539 16.0025 4.37565 16.0025 4.55318C16.0025 4.73072 15.932 4.90098 15.8065 5.02652L10.3598 10.4732C10.0497 10.7825 9.68161 11.0277 9.27667 11.1947C8.87172 11.3617 8.43783 11.4473 7.9998 11.4465Z",
    fill: "#1D1D1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2618_104832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.451e253c75cb4cd6a6dcd461edd9fd74.svg";
export { ForwardRef as ReactComponent };